import * as st from "lib/utils/socialtravel";
import InstallmentDecorator from "./InstallmentDecorator";

export default class PaymentProfileInstallmentDecorator extends InstallmentDecorator {
  static get transfer_type_options() {
    return [
      ["cash", I18n.humanAttributeName("order_installment", "cash")],
      ["online_payment", I18n.humanAttributeName("order_installment", "online_payment")],
      ["bank_wire", I18n.humanAttributeName("order_installment", "bank_wire")],
    ];
  }

  static get paid_by_types() {
    return [
      ["exact_date", I18n.humanAttributeName("order_installment", "exact_date")],
      [
        "x_days_after_previous_installment",
        I18n.humanAttributeName("order_installment", "x_days_after_previous_installment"),
      ],
      ["x_days_after_order_creation", I18n.humanAttributeName("order_installment", "x_days_after_order_creation")],
      [
        "x_days_after_order_company_approval",
        I18n.humanAttributeName("order_installment", "x_days_after_order_company_approval"),
      ],
      [
        "x_days_after_order_full_approval",
        I18n.humanAttributeName("order_installment", "x_days_after_order_full_approval"),
      ],
      ["x_days_before_stock_starts_at", I18n.humanAttributeName("order_installment", "x_days_before_stock_starts_at")],
    ];
  }

  static build(data = {}) {
    return new this({
      id: null,
      uuid: st.generateUuid(),
      type: "PaymentProfileInstallment",
      ...data,
    });
  }

  get is_exact_amount() {
    return ["exact_amount_per_order", "exact_amount_per_item", "exact_amount_per_person"].includes(this.amount_type);
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/PaymentProfileInstallmentDecorator.js